export const TouchlessEntity = `query entity($entityid:ID!){
    entity(entityid:$entityid){
  entityid,businessname,brandname,firstname,lastname,email,phonenumber,entitytypeid,businesstypeid,jobid, logourl,
  tags,website,shortdesc,fulldesc,policy,terms}}`;
